// TODO: find out why accept={...} doesn't work
const Input = ({ error, id, label, required, ...props }) => {
  return (
    <div>
      <label htmlFor={id} className="block text-text-body text-sm font-bold mb-2">
        {label} {required && <span className="text-required">*</span>}
      </label>
      <input
        {...props}
        id={id}
        required={required}
        aria-invalid={!!error}
        aria-describedby={error ? `${id}-error` : undefined}
        className={`border rounded px-4 py-3 bg-surface w-full focus:outline-none focus:ring-2 focus:ring-primary ${
          error ? "border-error" : "border-border-default"
        }`}
      />
      {error && (
        <span id={`${id}-error`} role="alert" className="text-error text-xs">
          {error}
        </span>
      )}
    </div>
  );
};

export default Input;
